<template>
  <app-collapse>
    <app-collapse-item
      title=""
      class="payment-item"
    >
      <template #header>
        <div class="ml-2 text-secondary d-flex w-100">
          <template v-if="card.brand === 'visa'">
            <img
              class="icon-left"
              :src="require('@/assets/svg/visa-card.svg')"
            >
          </template>
          <template v-else-if="card.brand === 'master'">
            <img
              class="icon-left"
              :src="require('@/assets/svg/master-card.svg')"
            >
          </template>
          <template v-else>
            <GjIcon
              class="icon-left"
              size="28"
              name="Payment"
            />
          </template>
          <span> •••• •••• •••• {{ card.last4 }}</span>
          <a
            v-if="showDelete"
            class="ml-auto"
            @click="$emit('delete', card.id)"
          >
            <GjIcon name="Delete" />
          </a>
        </div>
      </template>
      <loading-page v-if="loading" />
      <div
        v-else
        class="payment-method-info"
      >
        <div>
          <label>Name</label> {{ cardDetails.name || '-' }}
        </div>
        <div>
          <label>Number</label> {{ '•••• ' + cardDetails.last4 }}
        </div>
        <div>
          <label>Fingerprint</label> {{ cardDetails.fingerprint || '-' }}
        </div>
        <div>
          <label>Expires</label> {{ cardDetails.expMonth+'/'+cardDetails.expYear || '-' }}
        </div>
        <div class="text-capitalize">
          <label>Type</label> {{ cardDetails.brand || '-' }}
        </div>
        <div>
          <label>Issuer</label> {{ cardDetails.issuer || '-' }}
        </div>
        <div>
          <label>ID</label> {{ cardDetails.id || '-' }}
        </div>
        <div>
          <label>Origin</label> {{ findCountry(cardDetails.origin) || '-' }}
        </div>
        <div class="text-capitalize">
          <label>CVC Check</label> {{ cardDetails.cvcCheck || '-' }}
        </div>
        <div>
          <label>Default Payment Method</label> {{ cardDetails.isDefaultPaymentMethod ? 'Yes': 'No' }}
        </div>
      </div>
    </app-collapse-item>
  </app-collapse>
</template>
<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import contries from '../../countries'

export default {
  name: 'CardElement',
  components: { AppCollapse, AppCollapseItem },
  props: {
    card: {
      type: Object,
      required: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      contries,
      loading: true,
      cardDetails: {},
    }
  },
  created() {
    this.$store.dispatch('payments/getPaymentMethod', this.card.id)
      .then(response => { this.cardDetails = response.data.result })
      .finally(() => { this.loading = false })
  },
  methods: {
    findCountry(code) {
      return this.contries.find(c => c.code === code.toLowerCase())?.text
    },
  },
}
</script>
<style lang="scss" scoped>
.payment-item::v-deep {
  .card-header {
    border: none !important;
    padding: 0 !important;
    &::after {
      background-size: 24px;
      right: auto;
    }
  }
}

.payment-method-info {
  border-top: 1px solid #E0E5EB;
  padding-top: 24px;
  label {
    min-width: 170px;
  }
}
</style>
